import React from 'react';
import { render } from 'react-dom';
import { configureStore } from '@its/redux';
import reducer from './reducer';
import initialState from './initialState';
import routes from './routes/';
import App from '@its/components/lib/App';
import './assets/reset.css';
import './assets/fonts.scss';
import './assets/style.css';
import icon from './images/favicon.ico';
import { setFavicon } from '@its/util';
// import { initExceptionHandler } from '@its/util';

(() => {
  // initExceptionHandler();
  setFavicon(icon);

  const store = configureStore({
    reducer,
    initialState,
  });

  // Debug, hot load
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducer', () => {
      const nextReducer = require('./reducer');
      store.replaceReducer(nextReducer);
    });
  }

  render(
    <App
      routes={routes}
      store={store}
    />,
    document.getElementById('root')
  );
})();



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/